import { useQueries, useQuery } from "@tanstack/react-query";

import {
	getGoalReportDistributionData,
	getGridDataCount,
	getRawReviewReportData,
	getReviewReportDistributionData,
	getSurveyReportDistributionData,
} from "../services";

// TO DO: variables verification. Conditonally call api based on variables.
// In this case we only want to call api if summarizeBy is not empty.
export const useGetRawReviewReportData = (variables, canViewVisualizations = false, reportType = "reviewReport") => {
	const queries = variables.map((variable) => {
		const { summarizeBy } = variable;
		let isQueryEnabled = true;
		if (summarizeBy.length === 0 || !canViewVisualizations) {
			isQueryEnabled = false;
		}
		return {
			queryKey: ["getRawReviewReportData", variable, reportType],
			queryFn: () => getRawReviewReportData(variable, reportType),
			enabled: isQueryEnabled,
		};
	});
	return useQueries({ queries });
};

export const useGetGridDataCount = (variables, reportType = "reviewReport") => {
	return useQuery({
		queryKey: ["getGridDataCount", variables, reportType],
		queryFn: () => getGridDataCount(variables, reportType),
	});
};

export const useGetReportDistributionData = (variables, reportType = "reviewReport") => {
	const queries = variables.map((variable) => {
		const { summarizeBy, selectedColumnAggregationOperation } = variable;
		let isQueryEnabled = true;
		if (summarizeBy.length === 0 || !selectedColumnAggregationOperation) {
			isQueryEnabled = false;
		}

		if (reportType === "reviewReport") {
			return {
				queryKey: ["getReviewReportDistributionData", variable],
				queryFn: () => getReviewReportDistributionData(variable),
				enabled: isQueryEnabled,
			};
		} else if (reportType === "goalReport") {
			return {
				queryKey: ["getGoalReportDistributionData", variable],
				queryFn: () => getGoalReportDistributionData(variable),
				enabled: isQueryEnabled,
			};
		} else if (reportType === "surveyReport") {
			return {
				queryKey: ["getSurveyReportDistributionData", variable],
				queryFn: () => getSurveyReportDistributionData(variable),
				enabled: isQueryEnabled,
			};
		}
	});
	return useQueries({ queries });
};
